import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById, GetRoomType } from "adminApi/PromoCodeApi/Promocode";
import { validateForm } from "utils/validation";
import { PromoCodeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditPromoCodeForm from "./Componates/EditPromoCode";
import fields from "../json/PromoCodeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";

const EditPromoCode = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;

  // Build initial values from field definitions
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues, setErrors, handleFileChange } = useFormChange(
    initialValues,
    PromoCodeRules
  );

  // Fetch existing record by ID and populate form
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

  // Fetch room types for the select dropdown
  const { data: roomTypeOptions, loading: loadingRoomType } = useFetchAllData(GetRoomType);

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    // Send FormData for file uploads like User module
    async (formValues) => {
      const formData = new FormData();
      delete formValues.imagePreview;
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, PromoCodeRules);
      setErrors(err);
      return err;
    },

    () => navigate(-1),
    "Promo Code updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit || loadingRoomType) && <Spinner isSpinner={true} />}
      <EditPromoCodeForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        roomTypeOptions={roomTypeOptions || []}
        title="Edit Promo Code"
        imagePreview={values.imagePreview || values.image}
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default EditPromoCode;
